import React from "react";
import useTranslation from "next-translate/useTranslation";
import Popup from "@/components/ui/popup";
import { initWebsocketConnect } from "../services/websocket";
import { setOtherLoginShow, useWsConnection } from "../redux/wsConnection";
import { Button } from "@/components/ui/button";

export default function OtherLoginPopup() {
  const { t } = useTranslation("common");

  const { otherLoginShow } = useWsConnection();

  if (!otherLoginShow) {
    return null;
  }

  return (
    <Popup onClose={null} title={t("Another login has been detected")}>
      <div className="flex justify-center items-center pt-4 mt-4 w-full">
        <Button
          variant="default"
          size="wide"
          onClick={() => {
            setOtherLoginShow(false);
            initWebsocketConnect();
          }}
        >
          {t("Reconnect")}
        </Button>
      </div>
    </Popup>
  );
}
